import product from "./product";

export default {
    product,

    noAvailableItems: "Nessun prodotto disponibile su ordinazione."
}